import { render, staticRenderFns } from "./Logo_IMA.vue?vue&type=template&id=3da6c067&scoped=true&"
var script = {}
import style0 from "./Logo_IMA.vue?vue&type=style&index=0&id=3da6c067&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6c067",
  null
  
)

export default component.exports